module.exports = ":host {\r\n  padding: 20px;\r\n}\r\n"